
/**
 * A set of constants describing message names, where these messages are sent between windows in order to propagate
 * and handle Instructor feedback actions.
 */
export const InstructorFeedbackMessages = {
    'CAR_FEEDBACK': 'instructor-feedback-car',
    'CLOSE': 'instructor-feedback-close',
    'FOCUS': 'instructor-feedback-focus',
    'LIVE_FEEDBACK': 'instructor-feedback-livefeedback',
    'LIVE_FEEDBACK_CONTENT' : 'instructor-feedback-ax',
    'QUICKFIX_ERROR': 'instructor-feedback-quickfix-error',
    'SHOW': 'instructor-feedback-show'
};
